import React, { FC } from 'react';
import styled, { css } from 'styled-components';
import { Small } from '../TypographyNew';
import { TrevorIcon, TrevorIconName } from '../TrevorIcon';
import {
  SwitchButton,
  SwitchButtonContainer,
  SwitchContainer,
  SwitchLoading,
} from './Switch.styles';

type SwitchProps = {
  loading?: boolean;
  iconName?: TrevorIconName;
  checkedLabel?: string;
  uncheckedLabel?: string;
  checked?: boolean;
  onChange: F<boolean>;
};

export const Switch: FC<SwitchProps> = ({
  loading,
  iconName,
  checked = false,
  checkedLabel,
  uncheckedLabel,
  onChange,
}) => {
  return (
    <SwitchContainer>
      {loading && <SwitchLoading />}
      <SwitchButtonContainer
        checked={checked}
        onClick={() => onChange(!checked)}
      >
        <SwitchButton>
          {iconName && <TrevorIcon name={iconName} />}
        </SwitchButton>
        <Small>{checked ? checkedLabel : uncheckedLabel}</Small>
      </SwitchButtonContainer>
    </SwitchContainer>
  );
};
